import React, { createContext, useContext, useState, useCallback } from "react";

type ConfirmNavigationFn = (onConfirm: () => void) => void;

interface NavigationBlockerContextType {
  confirmNavigation: ConfirmNavigationFn | null;
  setConfirmNavigation: (fn: ConfirmNavigationFn | null) => void;
}

const NavigationBlockerContext = createContext<NavigationBlockerContextType>({
  confirmNavigation: null,
  setConfirmNavigation: () => {},
});

export const NavigationBlockerProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [confirmFn, setConfirmFn] = useState<ConfirmNavigationFn | null>(null);

  const setConfirmNavigation = useCallback((fn: ConfirmNavigationFn | null) => {
    setConfirmFn(() => fn);
  }, []);

  return (
    <NavigationBlockerContext.Provider
      value={{ confirmNavigation: confirmFn, setConfirmNavigation }}
    >
      {children}
    </NavigationBlockerContext.Provider>
  );
};

export const useNavigationBlockerContext = () =>
  useContext(NavigationBlockerContext);
